<template>
    <div class="products_without_groups__header">
        <div class="products_without_groups__header_search">
            <search_block
                :placeholderText="__t('O.SEARCH_PRODUCTS')"
                @search_input_data="searchInputData"
            />
        </div>
        <button class="products_without_groups__header_button" @click.prevent="clickSearchData">
            <div class="products_without_groups__header_button_icon">
                <font-awesome-icon icon="fa-solid fa-magnifying-glass"/>
            </div>
        </button>
        <button class="products_without_groups__header_button" :class="classButtonFilter"
                @click.prevent="clickShowFilter">
            <img src="/icons/filter_light.svg">
        </button>
        <button class="products_without_groups__header_button" @click.prevent="clickResetFilter">
            <div class="products_without_groups__header_button_icon">
                <font-awesome-icon icon="fa-regular fa-rectangle-xmark"/>
            </div>
        </button>
    </div>
    <div v-if="isShowFilter" class="products_without_groups__filters">
        <div class="products_without_groups__filters_input">
            <spinner_dots
                v-if="isLoadedStopListRestaurantsLocations"
                :key="'spinner_dots_restaurants'"
                :size="'10px'"
            />
            <div v-else class="products_without_groups__filters_input_block">
                <div class="products_without_groups__filters_input_block_select">
                    <v_select
                        :key="'filter_restaurants'"
                        :placeholder="selectRestaurantPlaceholder"
                        :options="listFilterRestaurants"
                        label="title"
                        v-model="selectedRestaurant"
                        @update:modelValue="updateRestaurantFilter"
                    >
                        <template #selected-option="{ title }">
                            <div class="selected-item">
                                <font-awesome-icon icon="fa-solid fa-utensils"/>
                                <span style="margin-left: 8px;">{{ title }}</span>
                            </div>
                        </template>

                        <template #option="{ title }">
                            <div class="dropdown-item">
                                <font-awesome-icon icon="fa-solid fa-utensils"/>
                                <span style="margin-left: 8px;">{{ title }}</span>
                            </div>
                        </template>

                    </v_select>
                </div>
            </div>
        </div>
        <div class="products_without_groups__filters_input">
            <spinner_dots
                v-if="isLoadedStopListRestaurantsLocations"
                :key="'spinner_dots_locations'"
                :size="'10px'"
            />
            <div v-else class="products_without_groups__filters_input_block">
                <div class="products_without_groups__filters_input_block_select">
                    <v_select
                        :key="'filter_locations'"
                        :placeholder="selectLocationPlaceholder"
                        :options="listFilterLocations"
                        label="title"
                        v-model="selectedLocation"
                        @update:modelValue="updateLocationFilter"
                    >

                        <template #selected-option="{ title }">
                            <div class="selected-item">
                                <font-awesome-icon icon="fa-solid fa-location-dot"/>
                                <span style="margin-left: 8px;">{{ title }}</span>
                            </div>
                        </template>

                        <template #option="{ title }">
                            <div class="dropdown-item">
                                <font-awesome-icon icon="fa-solid fa-location-dot"/>
                                <span style="margin-left: 8px;">{{ title }}</span>
                            </div>
                        </template>

                    </v_select>
                </div>
            </div>
        </div>
    </div>
    <table_data
        :key="'table_data'"
        :totalPagination="totalPagesStopListProducts"
        :isShowFilter="isShowFilter"
        @click_button_page="clickButtonPage"
    />
</template>

<script>

import {createHelpers} from "vuex-map-fields";
import burger_menu from "../../../heading/BurgerMenu.vue";
import {screenSize} from "../../../../mixins/screenSize";
import spinner_button from "../../../loader/SpinnerButton.vue";
import search_block from "../../SearchBlock.vue";
import v_select from 'vue-select';
import spinner_dots from "../../../loader/SpinnerDots.vue";
import table_data from "../../../table/TableData.vue";
import cloneData from "../../../../mixins/cloneData";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})
const {mapFields: mStopList} = createHelpers({
    getterType: 'stop_list/getStopListField',
    mutationType: 'stop_list/updateStopListField',
})

export default {
    name: "products_select_stop_list",
    props: {},
    emits: [],
    mixins: [screenSize, cloneData],
    components: {
        spinner_dots,
        search_block,
        spinner_button,
        burger_menu,
        v_select,
        table_data
    },
    data() {
        return {
            searchData: '',
            isShowFilter: false,
            selectedRestaurant: null,
            selectedLocation: null,
            filterData: {},
        }
    },
    beforeMount() {
        EventBus.$on('loaded_stop_list_products_without_filter', this.loadStopListProductsWithoutFilter);
        EventBus.$on('click_button_page', this.clickButtonPage);
        EventBus.$on('loaded_filter_restaurants_locations', this.loadFilterRestaurantsLocations);
    },
    mounted() {
        this.filterData = this.cloneData(this.filterStopList)
        this.$store.dispatch('stop_list/SET_STATES_LOADING_LIST', {
            actionName: 'setStatesLoadingList',
            statesLoading: ['isLoadedStopListProductsWithoutFilter'],
            stateLoad: true,
        });
        this.$store.dispatch('stop_list/GET_FILTER_STOP_LIST', {
            actionName: 'getFilterStopList'
        });
        if (this.filterStopList.tilter && this.filterStopList.tilter.search !== '') {
            this.searchData = this.filterStopList.tilter.search;
        }
        this.filterData.activePage = this.filterStopList.activePage;
    },
    beforeUnmount() {
        EventBus.$off('loaded_stop_list_products_without_filter', this.loadStopListProductsWithoutFilter);
        EventBus.$off('click_button_page', this.clickButtonPage);
        EventBus.$off('loaded_filter_restaurants_locations', this.loadFilterRestaurantsLocations);
    },
    methods: {
        clickSearchData() {
            this.filterData.isFilter = true;
            this.filterData.filter.search = this.searchData;
            this.setFilterStopList()
        },
        loadStopListProductsWithoutFilter(filter) {
            this.$store.dispatch('stop_list/SET_STATES_LOADING_LIST', {
                actionName: 'setStatesLoadingList',
                statesLoading: ['isLoadedStopListProductsWithoutFilter'],
                stateLoad: true,
            });
            this.$store.dispatch('stop_list/STOP_LIST_PRODUCTS_WITHOUT_FILTER', {
                actionName: 'getStopListProductsWithoutFilter',
                statesLoading: ['isLoadedStopListProductsWithoutFilter'],
                stateLoad: false,
                body: filter
            })
        },
        searchInputData(inputData) {
            this.searchData = inputData;
        },
        clickShowFilter() {
            this.isShowFilter = !this.isShowFilter;
            if (this.isShowFilter) {
                this.$store.dispatch('stop_list/SET_STATES_LOADING_LIST', {
                    actionName: 'setStatesLoadingList',
                    statesLoading: ['isLoadedStopListRestaurantsLocations'],
                    stateLoad: true,
                });
                this.$store.dispatch('stop_list/STOP_LIST_RESTAURANTS_LOCATIONS', {
                    actionName: 'stopListRestaurantsLocations',
                    statesLoading: ['isLoadedStopListRestaurantsLocations'],
                    stateLoad: false,
                })
            }
        },
        clickResetFilter() {
            this.selectedRestaurant = null;
            this.selectedLocation = null;
            EventBus.$emit('clear_search_data');
            this.filterData.restaurant = null;
            this.filterData.location = null;
            this.filterData.filter.search = '';
            this.setFilterStopList();
        },
        updateRestaurantFilter(value) {
        },
        updateLocationFilter(value) {
        },
        setFilterStopList() {
            this.loadStopListProductsWithoutFilter(this.filterData);
        },
        clickButtonPage(numberPage) {
            this.filterData.activePage = numberPage;
            if (this.filterData.hasOwnProperty('list')
                && this.filterData.list.hasOwnProperty('limit_start')
                && this.filterData.list.hasOwnProperty('limit')) {
                this.filterData.list.limit_start = (numberPage - 1) * this.filterData.list.limit;
            }
            this.filterData.isFilter = false;
            this.setFilterStopList();
        },
        loadFilterRestaurantsLocations() {
            if (this.filterStopList
                && this.filterStopList.restaurant
                && this.filterStopList.restaurant.id) {
                this.selectedRestaurant = this.listFilterRestaurants.find(item => item.id === this.filterStopList.restaurant.id)
            }
            if (this.filterStopList
                && this.filterStopList.location
                && this.filterStopList.location.id) {
                this.selectedLocation = this.listFilterLocations.find(item => item.id === this.filterStopList.location.id)
            }
        },
    },
    computed: {
        ...mUser([
            'user',
        ]),
        ...mStopList([
            'totalPagesStopListProducts',
            'activeItemStopListGroups',
            'isLoadedStopListRestaurantsLocations',
            'stopListFilterRestaurantsLocations',
            'filterStopList',
        ]),
        classButtonFilter() {
            if (this.isShowFilter) {
                return 'active';
            }
            return '';
        },
        selectLocationPlaceholder() {
            return `${this.__t('O.SELECT_FILTER_LOCATION')}`;
        },
        selectRestaurantPlaceholder() {
            return `${this.__t('O.SELECT_FILTER_RESTAURANT')}`;
        },
        listFilterRestaurants() {
            if (this.stopListFilterRestaurantsLocations
                && this.stopListFilterRestaurantsLocations.restaurants
                && Array.isArray(this.stopListFilterRestaurantsLocations.restaurants)) {
                return this.stopListFilterRestaurantsLocations.restaurants;
            }
            return [];
        },
        listFilterLocations() {
            if (this.stopListFilterRestaurantsLocations
                && this.stopListFilterRestaurantsLocations.locations
                && Array.isArray(this.stopListFilterRestaurantsLocations.locations)) {
                return this.stopListFilterRestaurantsLocations.locations;
            }
            return [];
        },
    },
    watch: {
        selectedRestaurant(newValue, oldValue) {
            this.filterData.restaurant = newValue;
            if (newValue !== oldValue) {
                this.filterData.isFilter = true;
                this.setFilterStopList();
            } else {
                this.filterData.isFilter = false;
            }
        },
        selectedLocation(newValue, oldValue) {
            this.filterData.location = newValue;
            if (newValue !== oldValue) {
                this.filterData.isFilter = true;
                this.setFilterStopList();
            } else {
                this.filterData.isFilter = false;
            }
        },
    }
}
</script>
